import React from "react"
import { FormattedMessage } from "react-intl"
import {
  Button,
  Popover,
  Box,
  PopoverProps
} from "@amzn/awsui-components-react"

interface IMessageConfig {
  id: string
  defaultMessage: string
  values?: Record<string, any>
}

interface IInfoPopoverProps {
  dataTestId: string
  position?: PopoverProps.Position
  messages: IMessageConfig[]
}

class InfoPopover extends React.PureComponent<IInfoPopoverProps> {
  render() {
    const { dataTestId, position, messages } = this.props
    return (
      <Popover
        data-testid={dataTestId}
        size="large"
        position={position}
        triggerType="custom"
        dismissButton={false}
        content={
          <>
            {messages.map(message => (
              <Box key={message.id} variant="p">
                <FormattedMessage
                  id={message.id}
                  defaultMessage={message.defaultMessage}
                  values={message.values}
                />
              </Box>
            ))}
          </>
        }
      >
        <Button
          variant="inline-icon"
          iconName="status-info"
          ariaLabel="Information"
        />
      </Popover>
    )
  }
}

export default InfoPopover
